import { provisionHeadlessBusiness } from '@wix/ambassador-headless-businesssetup-v1-no-entity/http'
import { ProvisionStep } from '@wix/ambassador-headless-businesssetup-v1-no-entity/types'

import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'

export const createHeadlessMetaSite = async (params: { origin: string }) =>
  withMonitoring(
    () =>
      ambassadorHttpClient.request(
        provisionHeadlessBusiness({
          origin: params.origin,
          // The metasite target oneof is mandatory; provisioning renames the site afterwards
          newMetasite: { namingStrategy: { defaultName: {} } },
          synchronousSteps: [ProvisionStep.SET_METASITE_NAME, ProvisionStep.CONFIGURE_HEADLESS_APP],
        }),
      ),
    'createHeadlessMetaSite',
  )
